import { render, staticRenderFns } from "./CatalogMenu.vue?vue&type=template&id=26091c5b"
import script from "./CatalogMenu.vue?vue&type=script&lang=js"
export * from "./CatalogMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/RoadConcepts/CatalogMenu.vue
// module id = 1058
// module chunks = 31